import { render } from "./Confirm.vue?vue&type=template&id=46a85ad7"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
script.render = render

export default script